import { render, staticRenderFns } from "./AddBankTransactionModal.vue?vue&type=template&id=5ba6562a&scoped=true&"
import script from "./AddBankTransactionModal.vue?vue&type=script&lang=js&"
export * from "./AddBankTransactionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddBankTransactionModal.vue?vue&type=style&index=0&id=5ba6562a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba6562a",
  null
  
)

export default component.exports